<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_193_10462)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_193_10462)" />
    </g>
    <path
      d="M13.9998 12.6667C12.7132 12.6667 11.6665 13.7133 11.6665 15C11.6665 16.2867 12.7132 17.3333 13.9998 17.3333C15.2865 17.3333 16.3332 16.2867 16.3332 15C16.3332 13.7133 15.2865 12.6667 13.9998 12.6667ZM13.9998 16C13.4465 16 12.9998 15.5533 12.9998 15C12.9998 14.4467 13.4465 14 13.9998 14C14.5532 14 14.9998 14.4467 14.9998 15C14.9998 15.5533 14.5532 16 13.9998 16ZM19.9998 18.6667C18.7132 18.6667 17.6665 19.7133 17.6665 21C17.6665 22.2867 18.7132 23.3333 19.9998 23.3333C21.2865 23.3333 22.3332 22.2867 22.3332 21C22.3332 19.7133 21.2865 18.6667 19.9998 18.6667ZM19.9998 22C19.4465 22 18.9998 21.5533 18.9998 21C18.9998 20.4467 19.4465 20 19.9998 20C20.5532 20 20.9998 20.4467 20.9998 21C20.9998 21.5533 20.5532 22 19.9998 22ZM12.6065 23.3333L11.6665 22.3933L21.3932 12.6667L22.3332 13.6067L12.6065 23.3333Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_193_10462"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.117647 0 0 0 0 0.294118 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_193_10462" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_193_10462" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_193_10462"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#0D8ABA" />
        <stop offset="1" stop-color="#0D7299" />
      </linearGradient>
    </defs>
  </svg>
</template>
